module.exports = __webpack_public_path__ + "img/a2bf64c.jpg";